export default __webpack_public_path__ + "static/media/School Clubs flyer.22be32a9.pdf";